module.exports = __webpack_public_path__ + "img/floor3_1.9d58f4eb.png";